
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Die Sterberate von Covid-19 beträgt laut `}<Link disco href='https://cmmid.github.io/topics/covid19/severity/diamond_cruise_cfr_estimates.html' mdxType="Link">{`Berechnungen`}</Link>{` über
alle Altersgruppen 1,1% bei Fällen mit Symptomen (Case Fatality Rate). Wenn man auch die Fälle ohne Symptome miteinbezieht, sind es 0,5% (Infection Fatality Rate).
Diese Werte hat `}<Link disco href='https://twitter.com/AdamJKucharski/status/1235700923978129408?s=20' mdxType="Link">{`Adam Kucharski`}</Link>{`, Mathematiker und Epidemiologe an der London
School of Hygiene & Tropical Medicine, aktuell berechnet. Bei jüngeren Personen nehme der Wert ab (0,1%), bei älteren nehme er zu (5 bis 10%), wie er gegenüber
der `}<Link disco href='https://www.nytimes.com/2020/03/05/health/coronavirus-deaths-rates.html' mdxType="Link">{`«New York Times»`}</Link>{` erklärt. Diese Werte bestätigt auch der Schweizer
Epidemienforscher Christian Althaus auf `}<Link disco href='https://twitter.com/C_Althaus/status/1236287416278884357?s=20' mdxType="Link">{`Twitter`}</Link>{`, auch wenn seine berechnete
Sterberate über alle Altersgruppen mit `}<Link disco href='https://twitter.com/AdamJKucharski/status/1236275741597339648?s=20' mdxType="Link">{`1.6%`}</Link>{` etwas höher liegt.
Die meisten Wissenschaftler beziffern die Sterblichkeitsrate jener Personen mit Symptomen (Case Fatality Rate) zwischen 1 und 2%, beispielsweise auch hier in einer `}<Link disco href='https://www.medrxiv.org/content/10.1101/2020.03.30.20048264v1' mdxType="Link">{`Studie`}</Link>{` aus Südkorea vom 1. April. Damit bleibt es dabei, was ein grosser Teil der Forschung nun schon länger sagt: `}<strong parentName="p">{`Covid-19 ist fünf- bis fünfzehnmal so gefährlich wie die saisonale
Grippe, was die Sterblichkeit betrifft.`}</strong>{` Bei Influenza beträgt die Sterberate je nach Region und Saison 0,02 bis 0,3 Prozent. Influenzafälle
gibt es pro Jahr weltweit bis zu 900 Millionen, dabei sterben 200'000 bis 650'000 Personen, in der Schweiz sterben zwischen 300 und 2500 Personen
jährlich.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;